import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { IBulkActionJobSummary } from "./bulk-action-job-summary.model";

/**
 * Reads the bulk-action job summary for the results page. The per-chase results grid is driven by
 * the shared server-grid (which POSTs to the results endpoint directly), so it needs no method here.
 */
@Injectable({ providedIn: "root" })
export class BulkActionResultsService {
    constructor(
        @Inject(BASE_API_URL) private readonly baseApiUrl: string,
        private http: HttpClient
    ) { }

    getSummary(jobId: string, phase: string): Observable<IBulkActionJobSummary> {
        const url = `${this.baseApiUrl}bulkactionjob/${jobId}?phase=${phase}`;
        return this.http.get<IBulkActionJobSummary>(url);
    }

    getResultsUrl(jobId: string, phase: string): string {
        return `${this.baseApiUrl}bulkactionjob/${jobId}/results?phase=${phase}`;
    }

    executeJob(jobId: string): Observable<any> {
        const url = `${this.baseApiUrl}bulkactionjob/${jobId}/execute`;
        return this.http.post(url, {});
    }
}
